export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const sessionIdToName = {
  1: 'Admin',
  2: 'Admin-Assign Roles',
  3: 'Admin-Update Permissions',
  4: 'Attendance List',
  5: 'Company Docs',
  6: 'Dashboard',
  7: 'Employees',
  8: 'Leave Management',
  9: 'Occasions',
  10: 'Mark Attendance',
  11: 'Monthly View',
  12: 'Online Users',
  13: 'Payslip',
  14: 'Payroll',
  15: 'Regularize Attendance',
  16: 'Slack Status',
  17: 'Status',
};

export const AUTH_URL = process.env.REACT_APP_API_URL
export const attendaceListTableColumns = [
  {
    header: 'Employee',
    accessor: 'Name Data',
  },
  {
    header: 'Type',
    accessor: 'Type',
  },
  {
    header: 'Start Time',
    accessor: 'Start Time',
  },
  {
    header: 'End Time',
    accessor: 'End Time',
  },
  {
    header: 'Working Hours',
    accessor: 'Working Hour',
  },
  {
    header: 'Sessions',
    accessor: 'Log In/Out Count',
  },
  {
    header: 'Screenshots',
    accessor: 'ScreenShots',
  },
  {
    header: 'Actions',
    accessor: 'Actions',
  },
];

export const attendaceDetailTableColumns = [
  {
    header: 'Sn',
    accessor: 'sn',
  },
  {
    header: 'Date',
    accessor: 'date',
  },
  {
    header: 'Employee Active Hours',
    accessor: 'workingGrant',
  },
  {
    header: 'Screen Shots',
    accessor: 'screenshots',
  },
  {
    header: 'Working Hours',
    accessor: 'totalTime',
  },
  {
    header: 'View Details ',
    accessor: 'view',
  },
];
export const attendanceDetailsTable = [
  {
    header: 'HRMS Agent Login',
    accessor: 'hrmsAgentLogin',
  },
  {
    header: 'HRMS Agent Logout',
    accessor: 'hrmsAgentLogout',
  },
];

export const employeeCardTable = [
  {
    header: 'User',
    accessor: 'user',
  },
  {
    header: 'Name',
    accessor: 'name',
  },
  {
    header: 'Employee Status',
    accessor: 'empStatus',
  },
  {
    header: 'Phone Number',
    accessor: 'phoneNumber',
  },
  {
    header: 'Email',
    accessor: 'email',
  },
  {
    header: 'Action',
    accessor: 'action',
  },
];

export const monthlyAttendanceColums = [
  { header: 'Employee', accessor: 'name' },
  { header: 'Total Days', accessor: 'totalDays' },
  { header: 'Agent Hrs', accessor: 'agentHours' },
  {
    header: 'Expected Hrs',
    accessor: 'expectedWorking',
  },
  {
    header: 'Deficit',
    accessor: 'deficit',
  },
  { header: 'Paid Leave', accessor: 'paidLeaveCount' },
  { header: 'Unpaid Leave', accessor: 'unPaidLeaveCount' },

  { header: 'View', accessor: 'action' },
];
